import { drawRoundedPolygon, fitToSize, inflatePolygon, sizeOptionsOrDefault } from './utils';
import { Rectangle } from './Rectangle';
/**
 * A visual element that renders a diamond-shaped decision flowchart symbol.
 * Extends Rectangle and provides functionality for creating diamond/rhombus shapes.
 */
export class Decision extends Rectangle {
    /** @hidden */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const strokeWidth = this.options.stroke.width || 0;
        const points = [
            { x: 0, y: height / 2 },
            { x: width / 2, y: 0 },
            { x: width, y: height / 2 },
            { x: width / 2, y: height }
        ];
        const inflated = inflatePolygon(points, this.options.cornerRadius);
        drawRoundedPolygon(drawingElement, inflated, this.options.cornerRadius);
        fitToSize(drawingElement, width, height, strokeWidth);
    }
}
